@if (station()) {
  <div class="is-flex is-space-between">
    <div class="is-flex is-column gap-8 is-justify-space-around is-flex-grow-1">
      <app-text class="text-14 is-family-semiBold">{{ 'app.__TYPE_WIND' | AsyncLang | async }}</app-text>
      <div class="is-flex">
        <div class="wind-data is-flex is-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'settings.__WIND_UNIT' | AsyncLang | async }}</app-text>
          <div class="is-flex is-align-baseline gap-4">
            <app-text class="text-blue text-18 is-family-medium">{{ windStrength() | toUserUnit: type | toDisplayValue: type }}</app-text>
            <app-text class="text-16 is-family-semiBold text-grey-50" unit [measureType]="type" />
          </div>
        </div>
        <div class="wind-data is-flex is-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'station.__GUST_SPEED' | AsyncLang | async }}</app-text>
          <div class="is-flex is-align-baseline gap-4">
            <app-text class="text-blue text-18 is-family-medium">{{ gustStrength() | toUserUnit: type | toDisplayValue: type }}</app-text>
            <app-text class="text-16 is-family-semiBold text-grey-50" unit [measureType]="type" />
          </div>
        </div>
      </div>
    </div>

    <app-wind-icon [windStrength]="windStrength()" [windAngle]="windAngle()"/>
  </div>
}
